import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    defaultProcessAreaRoleRelationResource,
    ProcessAreaRoleRelationMutationResourceSchema,
    type ProcessAreaRoleRelationResource,
    useProcessAreaRoleRelationActions,
} from '../../../../../resource/resources/artifacts/role/processAreaRoleRelationResource';
import { EditChildBaseDialog } from '../../../../reusable-components/dialogs/EditChildBaseDialog';
import { Form_DisplayComponentBaseView } from '../../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { creationDialogOnSuccess } from '../../../../util/utilFunctions';
import { ProcessAreaRoleRelationContent } from './ProcessAreaRoleRelationContent';

export const ProcessAreaRoleRelationCreationDialog = ({
    onClose,
    parentId,
    autoGeneratedProps,
    onCreated,
}: {
    onClose: () => void;
    parentId: string;
    autoGeneratedProps?: ProcessAreaRoleRelationResource;
    onCreated?: (id: string, objectId: string) => void;
}) => {
    const processAreaRoleRelationActions = useProcessAreaRoleRelationActions();
    const addProcessAreaRoleRelation = processAreaRoleRelationActions.useAddResource();

    const { form, formNames, onSubmit } = useMyForm({
        schema: ProcessAreaRoleRelationMutationResourceSchema,
        defaultValues: {
            ...defaultProcessAreaRoleRelationResource,
            ...autoGeneratedProps,
        },
        submitHandler: async (data) => {
            await addProcessAreaRoleRelation.mutateAsync(
                {
                    resource: data,
                    parentId,
                },
                {
                    onSuccess: creationDialogOnSuccess(onCreated, onClose),
                }
            );
        },
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Create Role Relation'}
            resourceType={ResourceType.PROCESS_AREA_ROLE_RELATION}
        >
            <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={true}>
                <ProcessAreaRoleRelationContent form={form} formNames={formNames} readOnly={false} />
            </Form_DisplayComponentBaseView>
        </EditChildBaseDialog>
    );
};
